
"use strict";

import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG_AUX_FUNCTIONS } from "../util/classes";
import { Whisper } from "../util/classes";
import { UTL } from "../util/classes";
import { Catlist } from "../util/classes";
import { TABLE, TableObject, TBLSCROLLER, TABLE_Location } from "../util/classes";

/**
 * DIALOG30 Static Class
 * חלון לבחירה מתוך רשימת קטגוריות (catlist) בתוך טבלה
 */
export class DIALOG30 {
    // --- Static Elements (Variables) ---
    public static overlay_element: HTMLDivElement = null;
    public static popup_element: HTMLDivElement = null;
    public static caption_element: HTMLDivElement = null;
    public static case_element: HTMLDivElement = null;
    public static taco_element: HTMLDivElement = null; // taco = Table COntainer
    public static table_element: HTMLTableElement = null;
    public static close_button_element: HTMLSpanElement = null;
    public static defo_button_element: HTMLSpanElement = null;
    public static panel_element: HTMLDivElement = null;
    public static ok_button_element: HTMLButtonElement = null;
    public static cancel_button_element: HTMLButtonElement = null;
    public static erase_button_element: HTMLButtonElement = null;

    // --- Static State Variables ---
    public static MD_FLAG = false;
    public static defo_button_is_clicked = false;
    public static Vamod_MouseX = 0;
    public static Vamod_MouseY = 0;
    public static Vamod_ModalWindowLeftX = 0;
    public static Vamod_ModalWindowTopY = 0;

    public static par_callback_function: Function = null;

    public static par_input_OBJ: oBase = null;
    public static VAR_CURRENT_ROW = /*2*/0;
    public static VAR_CURRENT_COLUMN = 0;
    public static par_catlist: Catlist = null;

    public static readonly BID = {
        UNDEFINED: 0,
        OK: 1,
        CANCEL: 2,
        ERASE: 3
    }; // note that we need this ';' because this block is a command 

    public static var_current_pseudo_focused_btn = 1; // BID.OK

    // --- Methods ---

    public static refresh_pseudo_focus_for_all_buttons() {
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG30.ok_button_element, DIALOG30.var_current_pseudo_focused_btn == DIALOG30.BID.OK);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG30.cancel_button_element, DIALOG30.var_current_pseudo_focused_btn == DIALOG30.BID.CANCEL);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG30.erase_button_element, DIALOG30.var_current_pseudo_focused_btn == DIALOG30.BID.ERASE);
    }

    public static respond_tab() {
        DIALOG30.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Forward(DIALOG30.var_current_pseudo_focused_btn, DIALOG30.BID.OK, DIALOG30.BID.ERASE);
        DIALOG30.refresh_pseudo_focus_for_all_buttons();
    }

    public static respond_shift_tab() {
        DIALOG30.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Backward(DIALOG30.var_current_pseudo_focused_btn, DIALOG30.BID.OK, DIALOG30.BID.ERASE);
        DIALOG30.refresh_pseudo_focus_for_all_buttons();
    }

    public static create_overlay_element() {
        const overlay_element = document.createElement("div");
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)"; // Semi-transparent black
        overlay_element.style.zIndex = "1000"; // Ensure overlay is on top
        return overlay_element;
    }

    public static create_popup_element() {
        const popup_element = document.createElement("div");
        popup_element.id = "id-DIALOG30-popup";
        popup_element.style.position = "absolute";
        popup_element.style.backgroundColor = "#fff";
        popup_element.style.backgroundColor = "lightgray";
        popup_element.style.padding = "0px";
        popup_element.style.borderRadius = "8px";
        popup_element.style.width = "320px";
        popup_element.style.textAlign = "center";

        //position: fixed;
        return popup_element;
    }

    public static create_caption_element() {
        const caption = document.createElement("div");
        caption.textContent = "DIALOG30";
        caption.style.fontSize = "24px";
        caption.style.fontWeight = "bold";
        caption.style.margin = "0px";
        caption.style.padding = "0px";
        caption.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_caption_backgroundColor();
        caption.style.color = DIALOG_AUX_FUNCTIONS.get_caption_forgroundColor();
        caption.style.borderTopLeftRadius = "5px";
        caption.style.borderTopRightRadius = "5px";
        caption.style.userSelect = "none";
        return caption;
    }

    public static create_case_element() {
        //-------------------------------------------------------------------------------------------------
        //                                     הוא האלמנט שתפקידו לקבל את הפוקוס case_element להזכירך ש
        //                                                     "keydown" :יקבל את האירוע overlay על מנת שה 
        //-------------------------------------------------------------------------------------------------
        const element = document.createElement("div");
        element.id = "id-DIALOG30-case"; // the id is for debug of focus
        element.style.backgroundColor = "yellow";
        element.style.width = "98%";
        //element.style.padding = "2px";
        element.style.margin = "auto";
        element.style.borderRadius = "0px";
        return element;
    }

    public static create_panel_element() {
        const buttonsContainer = document.createElement("div");
        buttonsContainer.style.marginTop = "15px";
        buttonsContainer.style.display = "flex";
        buttonsContainer.style.justifyContent = "space-around";
        buttonsContainer.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_panel_backgroundColor();
        buttonsContainer.style.marginBottom = "7px";
        return buttonsContainer;
    }

    public static overlay_mousedown(event: MouseEvent) {
        //alert("xx");
        //debugger;
        const target_element: HTMLElement = event.target as HTMLElement;
        const inside_table = TABLE.mouse_target_is_inside_table(target_element);
        //alert(`target_element = ${event.target}`);
        if (target_element == DIALOG30.caption_element) {
            // caption אנחנו רוצים שניתן יהיה לגרור רק דרך ה
            // caption אנחנו רוצים שניתן יהיה לגרור רק דרך ה
            const popup_element_bounding_rect = DIALOG30.popup_element.getBoundingClientRect();
            DIALOG30.MD_FLAG = true;
            DIALOG30.Vamod_MouseX = event.clientX;
            DIALOG30.Vamod_MouseY = event.clientY;
            DIALOG30.Vamod_ModalWindowLeftX = popup_element_bounding_rect.left; // use to be: parseFloat
            DIALOG30.Vamod_ModalWindowTopY = popup_element_bounding_rect.top; // use to be: parseFloat
        }
        if (target_element == DIALOG30.defo_button_element) {
            DIALOG30.defo_button_is_clicked = true;
        }
        if (target_element == DIALOG30.defo_button_element) {
            DIALOG30.defo_button_is_clicked = true;
        }
        if (inside_table == true) {
            //debugger;
            const row_number = TABLE.trans_mouse_target_to_row_number(target_element);
            const column_number = TABLE.trans_mouse_target_to_column_number(target_element);
            //alert(`inside_table: row_number=${row_number} column_number=${column_number}`);
            //debugger;
            if (row_number != (-1) && column_number != (-1)) {
                DIALOG30.REMOVE_MARK_FROM_CURRENT_ROW();
                DIALOG30.VAR_CURRENT_ROW = row_number;
                DIALOG30.VAR_CURRENT_COLUMN = column_number;
                DIALOG30.ADD_MARK_TO_CURRENT_ROW();
                if (false) {
                    DIALOG30.SCROLL_TO_CELL_INA();
                }
            }
        }
    }

    public static overlay_mousemove(event: MouseEvent) {
        if (DIALOG30.MD_FLAG == true) {
            //alert("mouse move");
            const delta_x = event.clientX - DIALOG30.Vamod_MouseX;
            const delta_y = event.clientY - DIALOG30.Vamod_MouseY;
            DIALOG30.popup_element.style.left = (DIALOG30.Vamod_ModalWindowLeftX + delta_x) + "px";
            DIALOG30.popup_element.style.top = (DIALOG30.Vamod_ModalWindowTopY + delta_y) + "px";
            //alert(`mousemove22: delta_x=${delta_x} delta_y=${delta_y}`);
        }
    }

    public static overlay_mouseup(event: MouseEvent) {
        const freezed_defo_button_is_clicked = DIALOG30.defo_button_is_clicked;
        DIALOG30.MD_FLAG = false;
        DIALOG30.defo_button_is_clicked = false;
        if (freezed_defo_button_is_clicked == false) {
            // כי זה יקלקל את הבדיקה case_element אנחנו לא רוצים לבצע פוקוס ל defo_button במקרה שבו לחצנו על ה
            // כי זה יקלקל את הבדיקה case_element אנחנו לא רוצים לבצע פוקוס ל defo_button במקרה שבו לחצנו על ה
            // כי זה יקלקל את הבדיקה case_element אנחנו לא רוצים לבצע פוקוס ל defo_button במקרה שבו לחצנו על ה
            DIALOG30.case_element.focus(); // body בורח ל focus כיוון שה focus יש לבצע כאן
        }
    }

    public static overlay_keydown(event: KeyboardEvent) {
        //alert("overlay_keydown");
        //event.preventDefault(); // <-- this disables the default behavior
        //return;
        //DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(erase_button_element, true);
        if (event.key === 'Enter') {
            //perform_ok();
            DIALOG30.perform_pseudo_focused_button();
        }
        if (event.key === 'Escape') {
            DIALOG30.perform_cancel();
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault(); // <-- this disables the default behavior
            DIALOG30.ADJ_UP();
        }
        if (event.key === 'ArrowDown') {
            event.preventDefault(); // <-- this disables the default behavior
            DIALOG30.ADJ_DOWN();
        }
        if (event.key === 'Tab') {
            event.preventDefault(); // <-- this disables the default behavior
            if (event.shiftKey == false) DIALOG30.respond_tab();
            if (event.shiftKey == true) DIALOG30.respond_shift_tab();
        }
    }

    public static create_result_OBJ(p_value_exist: boolean, p_value_conent: number) {
        const CONSTRUCTIOR = Object.getPrototypeOf(DIALOG30.par_input_OBJ).constructor;
        if (CONSTRUCTIOR === oInt64) {
            const OBJ = new oInt64(p_value_exist, p_value_conent);
            return OBJ;
        }
        alert("DIALOG30.error unknwon object");
    }

    public static call_callback(p_change_flag: boolean, p_value_exist: boolean, p_value_conent: number) {
        if (DIALOG30.par_callback_function != null) {
            document.body.removeChild(DIALOG30.overlay_element);
            const delay_in_milliseconds = 0;
            let OBJ = DIALOG30.create_result_OBJ(p_value_exist, p_value_conent);
            if (true) {
                // refresh כדי שיתבצע setTimeout() אנחנו משתמשים ב
                setTimeout(DIALOG30.par_callback_function, delay_in_milliseconds, p_change_flag, OBJ);
            }
            if (false) {
                DIALOG30.par_callback_function(p_change_flag, OBJ);
            }
        }
        else {
            alert("callback_function != null");
        }
    }

    public static perform_ok() {
        // כאן יש להשלים
        const code = DIALOG30.trans_row_to_code(DIALOG30.VAR_CURRENT_ROW);
        if (code == (-1)) {
            alert("perform_ok(). code== (-1)");
            return;
        }
        const change_flag = true;
        const value_exist = true;
        const value_content = code;

        DIALOG30.call_callback(change_flag, value_exist, value_content);
    }

    public static perform_cancel() {
        const change_flag = false;
        const value_exist = false; // although not needed
        const value_content = 0;  // although not needed
        // in this case we dont change value of static_bool_content
        DIALOG30.call_callback(change_flag, value_exist, value_content);
    }

    public static perform_defo() {
        // defo = DEbug FOcul
        // defo = DEbug FOcul
        // defo = DEbug FOcul
        UTL.show_which_element_has_focus();
    }

    public static perform_erase() {
        const change_flag = true;
        const value_exist = false; // this value !!!is needed!!!
        const value_content = 0;  // although not needed
        // in this case we dont change value of static_bool_content
        DIALOG30.call_callback(change_flag, value_exist, value_content);
    }

    public static create_new_br_element() {
        // אחד חשוב ליצור כל אחד בנפרד כאן <br> במידה ורוצים להוסיף יותר מאשר אלמנט
        const new_br_element = document.createElement('br');
        return new_br_element;
    }

    public static create_table_row(code: number, text: string) {
        const row = document.createElement('tr');
        const cell1 = document.createElement('td');
        cell1.textContent = String(code);
        const cell2 = document.createElement('td');
        cell2.textContent = text;
        row.appendChild(cell1);
        row.appendChild(cell2);
        return row;
    }

    public static create_table() {
        const table_element = document.createElement('table');
        table_element.id = 'id-table'; // debugging בגלל שזה אמור לעזור כאשר מבצעים ?id למה מוסיפים 

        const thead_element = document.createElement('thead');
        const tbody_element = document.createElement('tbody');
        table_element.appendChild(thead_element);
        table_element.appendChild(tbody_element);

        table_element.style.width = '100%';
        // Create a table row for the header
        const headerRow = document.createElement('tr');

        const th2 = document.createElement('th');
        th2.textContent = 'Name';  // text inside the header cell
        const th1 = document.createElement('th');
        th1.textContent = 'code';  // text inside the header cell

        // Add the header cell to the header row
        headerRow.appendChild(th1);
        headerRow.appendChild(th2);
        headerRow.style.position = "sticky";
        headerRow.style.top = "0";
        headerRow.style.zIndex = "1";
        headerRow.style.boxShadow = "0 2px 5px rgba(0, 0, 0, 0.2)";
        // Add the header row to the table
        thead_element.appendChild(headerRow);

        for (let i = 0; i < DIALOG30.par_catlist.ARR.length; i++) {
            const ipt = DIALOG30.par_catlist.GetRecordReference(i)
            tbody_element.appendChild(DIALOG30.create_table_row(ipt.code, ipt.text));
        }

        return table_element;
    }

    public static create_taco() {
        // taco = Table Container
        const div_element = document.createElement('div');
        div_element.id = 'id-taco'; // debugging בגלל שזה אמור לעזור כאשר מבצעים ?id למה מוסיפים 
        div_element.style.overflowY = 'auto';
        //div_element.style.backgroundColor = "orange";
        div_element.style.margin = "2px";
        //div_element.style.padding = "2px";
        div_element.style.height = "300px";
        //const table_element = create_table();
        //div_element.appendChild(table_element);
        return div_element;
    }

    public static ADD_MARK_TO_CURRENT_ROW() {
        const table_element = DIALOG30.table_element;
        const column_0 = 0;
        TABLE.given_table_element_add_class_str_to_cell(table_element, DIALOG30.VAR_CURRENT_ROW, column_0, "coin-layer1-background-green");
        const column_1 = 1;
        TABLE.given_table_element_add_class_str_to_cell(table_element, DIALOG30.VAR_CURRENT_ROW, column_1, "coin-layer3-background-green");
    }

    public static REMOVE_MARK_FROM_CURRENT_ROW() {
        const table_element = DIALOG30.table_element;
        const column_0 = 0;
        TABLE.given_table_element_remove_class_str_from_cell(table_element, DIALOG30.VAR_CURRENT_ROW, column_0, "coin-layer1-background-green");
        const column_1 = 1;
        TABLE.given_table_element_remove_class_str_from_cell(table_element, DIALOG30.VAR_CURRENT_ROW, column_1, "coin-layer3-background-green");
    }

    public static ADJ_UP() {
        if (DIALOG30.VAR_CURRENT_ROW > 0) {
            DIALOG30.REMOVE_MARK_FROM_CURRENT_ROW();
            DIALOG30.VAR_CURRENT_ROW -= 1;
            DIALOG30.ADD_MARK_TO_CURRENT_ROW();
            DIALOG30.SCROLL_TO_CELL_INA();
        }
    }

    public static ADJ_DOWN() {
        const table_obj = DIALOG30.create_table_object();
        const number_of_rows = TABLE.trans_table_element_to_number_of_rows(table_obj.table_element)
        if (DIALOG30.VAR_CURRENT_ROW < (number_of_rows - 1)) {
            DIALOG30.REMOVE_MARK_FROM_CURRENT_ROW();
            DIALOG30.VAR_CURRENT_ROW += 1;
            DIALOG30.ADD_MARK_TO_CURRENT_ROW();
            DIALOG30.SCROLL_TO_CELL_INA();
        }
    }

    public static create_table_object() {
        const table_obj = new TableObject();
        table_obj.table_element = DIALOG30.table_element;
        table_obj.taco_element = DIALOG30.taco_element;
        table_obj.has_vertical_scroll = true;
        table_obj.has_horizontal_scroll = false;
        table_obj.exist_head = true;
        table_obj.exist_numerator = false;
        table_obj.direction = "rtl";
        return table_obj;
    }

    public static SCROLL_TO_CELL_INA() {
        //alert("SCROLL_TO_CELL_INA");
        const table_obj = DIALOG30.create_table_object();
        TBLSCROLLER.scroll_to_cell_INA(table_obj, DIALOG30.VAR_CURRENT_ROW, DIALOG30.VAR_CURRENT_COLUMN);
    }

    public static trans_row_to_code(row: number) {
        const index: number = row;
        const ipt = DIALOG30.par_catlist.GetRecordReference(index)
        if (ipt != null) {
            return ipt.code;
        }
        else {
            return (-1);
        }
    }

    public static perform_pseudo_focused_button() {
        if (DIALOG30.var_current_pseudo_focused_btn == DIALOG30.BID.OK) {
            DIALOG30.perform_ok();
        }
        if (DIALOG30.var_current_pseudo_focused_btn == DIALOG30.BID.CANCEL) {
            DIALOG30.perform_cancel();
        }
        if (DIALOG30.var_current_pseudo_focused_btn == DIALOG30.BID.ERASE) {
            DIALOG30.perform_erase();
        }
    }

    public static create_dialog(p_callback_function: Function, p_input_OBJ: oBase, p_catlist: Catlist) {
        // catlist בא לשרת בחירת מתוך DIALOG30 החלון
        // catlist בא לשרת בחירת מתוך DIALOG30 החלון
        // catlist בא לשרת בחירת מתוך DIALOG30 החלון
        // catlist בא לשרת בחירת מתוך DIALOG30 החלון
        // catlist בא לשרת בחירת מתוך DIALOG30 החלון
        DIALOG30.par_callback_function = p_callback_function;
        DIALOG30.par_input_OBJ = p_input_OBJ;
        DIALOG30.par_catlist = p_catlist;

        DIALOG30.overlay_element = DIALOG30.create_overlay_element();
        DIALOG30.popup_element = DIALOG30.create_popup_element();
        DIALOG30.caption_element = DIALOG30.create_caption_element();
        DIALOG30.close_button_element = DIALOG_AUX_FUNCTIONS.create_close_button_element();
        try {
            DIALOG30.defo_button_element = DIALOG_AUX_FUNCTIONS.create_defo_button_element(); // defo = DEbug FOcul
        }
        catch (error) {
            alert(error);
        }

        DIALOG30.case_element = DIALOG30.create_case_element();
        DIALOG30.taco_element = DIALOG30.create_taco();
        DIALOG30.table_element = DIALOG30.create_table();

        DIALOG30.panel_element = DIALOG30.create_panel_element();
        DIALOG30.ok_button_element = DIALOG_AUX_FUNCTIONS.create_ok_button_element();
        DIALOG30.cancel_button_element = DIALOG_AUX_FUNCTIONS.create_cancel_button_element();
        DIALOG30.erase_button_element = DIALOG_AUX_FUNCTIONS.create_erase_button_element();

        DIALOG30.overlay_element.appendChild(DIALOG30.popup_element);
        DIALOG30.caption_element.appendChild(DIALOG30.close_button_element);
        DIALOG30.caption_element.appendChild(DIALOG30.defo_button_element);
        DIALOG30.popup_element.appendChild(DIALOG30.caption_element);
        DIALOG30.popup_element.appendChild(DIALOG30.create_new_br_element());

        DIALOG30.popup_element.appendChild(DIALOG30.case_element);
        DIALOG30.case_element.appendChild(DIALOG30.taco_element); // taco = TAble COntainer
        DIALOG30.taco_element.appendChild(DIALOG30.table_element); // taco = TAble COntainer

        DIALOG30.popup_element.appendChild(DIALOG30.panel_element);
        DIALOG30.panel_element.appendChild(DIALOG30.ok_button_element);
        DIALOG30.panel_element.appendChild(DIALOG30.cancel_button_element);
        DIALOG30.panel_element.appendChild(DIALOG30.erase_button_element);

        DIALOG30.overlay_element.addEventListener("mousedown", DIALOG30.overlay_mousedown);
        DIALOG30.overlay_element.addEventListener("mousemove", DIALOG30.overlay_mousemove);
        DIALOG30.overlay_element.addEventListener("mouseup", DIALOG30.overlay_mouseup);
        DIALOG30.overlay_element.addEventListener("keydown", DIALOG30.overlay_keydown);
        DIALOG30.defo_button_element.addEventListener("click", DIALOG30.perform_defo);
        DIALOG30.ok_button_element.addEventListener("click", DIALOG30.perform_ok);
        DIALOG30.cancel_button_element.addEventListener("click", DIALOG30.perform_cancel);
        DIALOG30.erase_button_element.addEventListener("click", DIALOG30.perform_erase);
        DIALOG30.close_button_element.addEventListener("click", DIALOG30.perform_cancel);

        document.body.appendChild(DIALOG30.overlay_element);
        UTL.center_popup_element_inside_overlay_element(DIALOG30.popup_element, DIALOG30.overlay_element);
        DIALOG30.var_current_pseudo_focused_btn = DIALOG30.BID.OK;
        DIALOG30.refresh_pseudo_focus_for_all_buttons();

        if (true) {
            DIALOG30.SCROLL_TO_CELL_INA();
        }
        DIALOG30.ADD_MARK_TO_CURRENT_ROW();

        //-------------------------------------------------------------------------------------------------
        //                                     הוא האלמנט שתפקידו לקבל את הפוקוס case_element להזכירך ש
        //                                                     "keydown" :יקבל את האירוע overlay על מנת שה 
        //-------------------------------------------------------------------------------------------------
        UTL.MakeElementFocusable(DIALOG30.case_element);
        DIALOG30.case_element.focus();
        //-------------------------------------------------------------------------------------------------
        //                                     הוא האלמנט שתפקידו לקבל את הפוקוס case_element להזכירך ש
        //                                                     "keydown" :יקבל את האירוע overlay על מנת שה 
        //-------------------------------------------------------------------------------------------------
    }
}